/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantAnagraficaDTO
 */
export interface TenantAnagraficaDTO {
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    localita?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    cap?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    indirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    numeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaDTO
     */
    id?: string;
}

/**
 * Check if a given object implements the TenantAnagraficaDTO interface.
 */
export function instanceOfTenantAnagraficaDTO(value: object): value is TenantAnagraficaDTO {
    return true;
}

export function TenantAnagraficaDTOFromJSON(json: any): TenantAnagraficaDTO {
    return TenantAnagraficaDTOFromJSONTyped(json, false);
}

export function TenantAnagraficaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantAnagraficaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'numeroCivico': json['numeroCivico'] == null ? undefined : json['numeroCivico'],
        'note': json['note'] == null ? undefined : json['note'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function TenantAnagraficaDTOToJSON(value?: TenantAnagraficaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'nazioneId': value['nazioneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'localita': value['localita'],
        'cap': value['cap'],
        'indirizzo': value['indirizzo'],
        'numeroCivico': value['numeroCivico'],
        'note': value['note'],
        'id': value['id'],
    };
}

